import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoWorld16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M9.49696 2.01626L8.76563 4.94572C8.7061 5.18434 8.51996 5.37077 8.2815 5.43077L6.30117 5.92894C6.11344 5.97617 5.95552 6.10266 5.86843 6.27554L5.69378 6.62224C5.50704 6.99294 5.0306 7.10468 4.6985 6.85574L2.50036 5.20784M9.49696 2.01626C9.01776 1.89677 8.51636 1.83334 8.00016 1.83334C5.59941 1.83334 3.51908 3.20524 2.50036 5.20784M9.49696 2.01626C12.1794 2.6851 14.1668 5.11047 14.1668 8.00001C14.1668 11.4057 11.4059 14.1667 8.00016 14.1667C4.59441 14.1667 1.8335 11.4057 1.8335 8.00001C1.8335 6.99501 2.07391 6.04616 2.50036 5.20784M7.80423 11.0365L6.9725 9.78894C6.79596 9.52414 6.83123 9.17148 7.05663 8.94688L7.19516 8.80888C7.33056 8.67394 7.51736 8.60368 7.70816 8.61581L8.52363 8.66788C8.64143 8.67541 8.75503 8.71401 8.85303 8.77988L10.1821 9.67301C10.4604 9.86001 10.5565 10.2246 10.4066 10.5245L10.1864 10.9648C10.0734 11.1907 9.84263 11.3333 9.5901 11.3333H8.3589C8.13603 11.3333 7.92783 11.2219 7.80423 11.0365Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoWorld16;